import React, { Component } from 'react';
import { Table, Modal, Button } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class InGroupRate extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        pagination: {
            current: 1,
            pageSize: 6,
        }
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            pagination: {
                current: 1,
                pageSize: 6,
            }
        });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { params } = this.props;
        const { record, pagination } = this.state;
        const { diseaseId, investigationAreaId, hospitalDepartmentId } = record;
        const { current, pageSize } = pagination;
        const limit = pageSize - 1;
        const options = {
            method: 'POST',
            url: API_URL.commentInfo.queryDepartmentInGroup,
            data: {
                offset: current,
                limit,
                ...params,
                diseaseId,
                investigationAreaId,
                hospitalDepartmentId,
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                let newData = [];
                pagination.total = 0;
                if (data && data.length > 0) {
                    const last = data.pop();
                    newData = data.slice((current - 1) * limit, current * limit);
                    newData.push(last);
                    pagination.total = Math.ceil(data.length / limit) * pageSize;
                }
                this.setState({
                    data: newData,
                    pagination,
                    loading: false,
                });
            }, errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getRender = (type) => {
        return (text, record) => {
            const { statisticalTime } = record;
            if (type === 'date') {
                text = text ? text.slice(0, 10) : '';
            }
            const obj = {
                children: text,
                props: {},
            };
            if (statisticalTime === '合计') {
                obj.children = text || text === 0 ? <strong>{text}</strong> : '';
            }
            return obj;
        }
    }

    getColumns = () => {
        const columns = [{
            title: '筛选入组时间',
            dataIndex: 'statisticalTime',
            key: 'statisticalTime',
            width: 120,
            render: this.getRender(),
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            render: this.getRender(),
        }, {
            title: '中心启动时间',
            dataIndex: 'startTime',
            key: 'startTime',
            width: 90,
            render: this.getRender(),
        }, {
            title: 'LPI',
            dataIndex: 'lpi',
            key: 'lpi',
            width: 80,
            render: this.getRender('date'),
        }, {
            title: 'open天数',
            dataIndex: 'openDay',
            key: 'openDay',
            width: 80,
            render: this.getRender(),
        }, {
            title: '筛选病例数',
            dataIndex: 'filterAmount',
            key: 'filterAmount',
            width: 80,
            render: this.getRender(),
        }, {
            title: '随机病例数',
            dataIndex: 'randomAmount',
            key: 'randomAmount',
            width: 80,
            render: this.getRender(),
        }, {
            title: '月入组速率',
            dataIndex: 'monthlyEnrollmentRate',
            key: 'monthlyEnrollmentRate',
            width: 80,
            render: this.getRender(),
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = (data || []).map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { record, visible, loading, pagination } = this.state;
        const { hospitalName, departmentName, investigationAreaName, diseaseName } = record;
        return (
            <Modal
                title="科室月入组速率"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="800px"
                maskClosable={false}
                footer={<Button type="ghost"onClick={this.hide}>关闭</Button>}
            >
                <div style={{ padding: 20 }}>
                    <div style={{ marginBottom: 10 }}>
                        医院：{hospitalName}
                        <span className="ant-divider" />
                        科室：{departmentName}
                        <span className="ant-divider" />
                        项目领域：{investigationAreaName}
                        <span className="ant-divider" />
                        疾病：{diseaseName}
                    </div>
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.index}
                        loading={loading}
                        onChange={this.handleTableChange}
                        pagination={pagination}
                    />
                </div>
            </Modal>
        );
    }
}

export default InGroupRate;


// WEBPACK FOOTER //
// ./src/components/siteComment/researchCenterRecommend/InGroupRate.js